module.exports = "<div class=\"kl-progress {class}\" r-hide={!visible}>\n  <div class=\"kl-progress-wrap kl-progress-wrap--{@(size)}\" >\n    <div class=\"kl-progress-wrap__bar\" style=\"width: {percent}%; background-color: {color};\">\n      {#if insideText && size == 'lg'}{percent}%{/if}\n    </div>\n  </div>\n  {#if this.$body}\n  <div class=\"kl-progress-slot\">\n    {#inc this.$body}\n  </div>\n  {/if}\n</div>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLProgress/index.html
// module id = 528
// module chunks = 0